module.exports = __webpack_public_path__ + "agile.1mT-T6Zx.svg";